<template>
  <div class="mstation-introduce-background">
    <div class="mstation-introduce-banner">
      <div class="mstation-introduce-container">
        <div class="mstation-introduce-banner-title">MSTATION</div>
      </div>

      <img class="mstation-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="mstation-introduce-container">

     <div class="mstation-introduce-content">
       <div class="mstation-introduce-content-title">
         <div class="mstation-introduce-content-title-text">桌面上的“超算”MSTATION</div>
         <div class="mstation-introduce-line"></div>
       </div>
       <div class="mstation-introduce-content-info">
         <p class="mstation-introduce-content-info-text">
           “MSTATION”定位于在材料模拟方面刚刚起步的研究人员，采用最新的Haswell架构V3 Intel ® Xeon ® CPU，具有多核、节能、低发热、价格优惠、性能优越等优点；采用最新的Pascal架构NVIDIA ®旗舰GPU，相比上一代在功率保持基本不变的前提下，性能提升巨大。</p>
         <p class="mstation-introduce-content-info-text">“龙讯”致力于打造（定制）高性能材料模拟工作站，为客户量身定制材料模拟解决方案，同时提供相关技术支持服务，为客户的科研项目顺利进行顺利开展提供贴心保障。</p>
       </div>

       <div class="mstation-introduce-content-img">
         <img class="mstation-introduce-content-img-png" src="../../assets/produce/mstation/mstation-product.jpg">
       </div>


       <div class="mstation-introduce-content-title">
         <div class="mstation-introduce-content-title-text">硬件配置信息</div>
         <div class="mstation-introduce-line"></div>
       </div>
       <div class="mstation-introduce-content-info">
         <p class="mstation-introduce-content-info-text">下面的表格展示了MSTATION和双机互联版的MSTATION的硬件配置</p>

         <table class="mstation-introduce-table">
           <tr class="mstation-introduce-th">
             <th class="mstation-introduce-text-th">硬件</th>
             <th class="mstation-introduce-text-th">MSTATION</th>
             <th class="mstation-introduce-text-th">双机互联版MSTATION</th>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">CPU</td>
             <td class="mstation-introduce-text-td">双路Intel ® Xeon ® CPU E5-2620 v4</td>
             <td class="mstation-introduce-text-td">双路Intel ® Xeon ® CPU E5-2620 v4</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">GPU</td>
             <td class="mstation-introduce-text-td">4路NVIDIA ® GTX 3080Ti/3090</td>
             <td class="mstation-introduce-text-td">最多8路 NVIDIA ® GTX 3080Ti/3090</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">内存</td>
             <td class="mstation-introduce-text-td">256GB DDR4</td>
             <td class="mstation-introduce-text-td">最大512GB DDR4</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">操作系统</td>
             <td class="mstation-introduce-text-td">CentOS 7.9</td>
             <td class="mstation-introduce-text-td">CentOS 7.9</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">IB交换网络</td>
             <td class="mstation-introduce-text-td"></td>
             <td class="mstation-introduce-text-td">有</td>
           </tr>
         </table>
       </div>

       <div class="mstation-introduce-content-title">
         <div class="mstation-introduce-content-title-text">购买MSTATION的巨大优势</div>
         <div class="mstation-introduce-line"></div>
       </div>
       <div class="mstation-introduce-content-info">
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>高性价比。使用PWmat，一台MSTATION相当于100~200CPU核的服务器性能，这些服务器大约耗资50万。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>一台MSTATION（包括各种预装软件以及PWmat）的售价仅仅相当于一个研究小组一年的计算费用。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>相比传统的CPU服务器，MSTATION更加安静，可以放在办公室之中，并不需要专业的计算机机房。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>MSTATION更加节能省电。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>MSTATION采用开箱即用的模式，省去配置各种文件库的烦恼，轻松无忧。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>有了MSTATION，无需等待，从此不再“排队”</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>预装 slurm 作业调度系统，满足各种后台调度需求</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>MSTATION还预装了大量的计算模拟软件LAMMPS、CP2K、Quantum Espresso。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>MSTATION充分实现了我们的一体化方案：从输入、系统分析、材料模拟、结果可视化都在一台机器上完成。</p>
         <p class="mstation-introduce-content-info-text"><i class="fa fa-thumbs-o-up mstation-introduce-fa"></i>完善的售后服务支持：对于各种实用问题，我们都能及时反馈给您。</p>

       </div>
     </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "companyIntroduce"
  }
</script>

<style scoped>
  .mstation-introduce-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .mstation-introduce-background{
    margin-top: 70px;
  }
  .mstation-introduce-banner{
    overflow:hidden;
  }
  .mstation-introduce-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .mstation-introduce-banner-img{
    min-width:100%;
    height:165px;
  }
  .mstation-introduce-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .mstation-introduce-content-img{
    text-align: center;
  }
  .mstation-introduce-content-img-png{
    margin-top: 50px;
    width: 300px;
  }
  .mstation-introduce-content-title{
    padding-top: 50px;
  }
  .mstation-introduce-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .mstation-introduce-content-info{
    margin-top: 40px;
  }
  .mstation-introduce-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .mstation-introduce-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }
  .mstation-introduce-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .mstation-introduce-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .mstation-introduce-td{
    height: 45px;
  }
  .mstation-introduce-td:hover{
    background:rgba(73,145,201,0.1);
  }
  .mstation-introduce-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .mstation-introduce-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding-left: 16px;
  }
  .mstation-introduce-fa{
    font-size: 16px;
    padding-right: 8px;
  }
  @media screen and (max-width:482px) {
    .mstation-introduce-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .mstation-introduce-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .mstation-introduce-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .mstation-introduce-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .mstation-introduce-container{
      max-width: 1068px;
    }
  }

</style>